import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftSecurityGroupSettings } from '../models/generated/ziroModels';

@Injectable()
export class MicrosoftSecurityGroupSettingsResource {
  protected http = inject(HttpClient);

  get(tenantId: number): Observable<MicrosoftSecurityGroupSettings> {
    return this.http.get<MicrosoftSecurityGroupSettings>(
      `/services/microsoft/admin/tenants/${tenantId}/security-group-settings`,
    );
  }

  put(tenantId: number, data: MicrosoftSecurityGroupSettings): Observable<void> {
    return this.http.put<void>(`/services/microsoft/admin/tenants/${tenantId}/security-group-settings`, data);
  }
}
